import React from 'react';

import { Modal, Typography, Button } from 'antd';

import { translations, TranslationKey } from '../config/translations';

const { Text } = Typography;

type Props = {
  open: boolean;
  onClose: () => void;
  language?: 'en' | 'fr';
};

const ClientIdHelpModal: React.FC<Props> = ({ open, onClose, language = 'fr' }) => {
  const isFr = language === 'fr';

  // Function to translate using the language passed as props
  const translate = (key: TranslationKey): string => {
    const langTranslations = translations[language];
    return langTranslations[key] || translations.fr[key] || key;
  };

  return (
    <Modal
      title={null}
      open={open}
      onCancel={onClose}
      footer={null}
      width="95vw"
      style={{ maxWidth: '1400px', top: 20 }}
      bodyStyle={{
        padding: '24px',
        maxHeight: '90vh',
        overflow: 'auto',
        backgroundColor: '#f5f5f5',
      }}
      closeIcon={
        <div
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: '#ff4d4f',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            color: 'white',
            fontWeight: 'bold',
            cursor: 'pointer',
            marginTop: '8px',
            marginRight: '15px',
          }}
        >
          ×
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* Title with info cards above */}
        <div>
          <Typography.Title
            level={2}
            style={{
              margin: 0,
              color: '#1890ff',
              textAlign: 'center',
              marginBottom: '20px',
            }}
          >
            💡 {translate('searchOrder.whereToFind')}
          </Typography.Title>

          {/* Info cards in title area - side by side, wider layout */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '24px',
              marginBottom: '8px',
              flexWrap: 'wrap',
            }}
          >
            {/* Client number */}
            <div
              style={{
                backgroundColor: '#fffbe6',
                padding: '12px 24px',
                borderRadius: '10px',
                border: '3px solid #faad14',
                textAlign: 'center',
                minWidth: '280px',
                maxWidth: '400px',
                flex: '1 1 320px',
              }}
            >
              <div style={{ fontSize: '28px', marginBottom: '6px' }}>📋</div>
              <Typography.Title
                level={5}
                style={{
                  margin: 0,
                  color: '#d48806',
                  marginBottom: '6px',
                  fontSize: '16px',
                }}
              >
                {translate('searchOrder.clientNumber')}
              </Typography.Title>

              <Typography.Text
                style={{ fontSize: '15px', display: 'block', marginBottom: '3px' }}
              >
                {translate('searchOrder.clientNumberExample')}{' '}
                <Text code style={{ fontSize: '17px', fontWeight: 700 }}>
                  123456
                </Text>
              </Typography.Text>

              <Typography.Text style={{ fontSize: '12px', color: '#8c8c8c' }}>
                {translate('searchOrder.topLeftInvoice')}
              </Typography.Text>
            </div>

            {/* Order number */}
            <div
              style={{
                backgroundColor: '#e6f7ff',
                padding: '12px 24px',
                borderRadius: '10px',
                border: '3px solid #1890ff',
                textAlign: 'center',
                minWidth: '280px',
                maxWidth: '400px',
                flex: '1 1 320px',
              }}
            >
              <div style={{ fontSize: '28px', marginBottom: '6px' }}>🛒</div>
              <Typography.Title
                level={5}
                style={{
                  margin: 0,
                  color: '#0050b3',
                  marginBottom: '6px',
                  fontSize: '16px',
                }}
              >
                {translate('searchOrder.orderNumber')}
              </Typography.Title>

              <Typography.Text
                style={{ fontSize: '15px', display: 'block', marginBottom: '3px' }}
              >
                {translate('searchOrder.clientNumberExample')}{' '}
                <Text code style={{ fontSize: '17px', fontWeight: 700 }}>
                  01218202
                </Text>
              </Typography.Text>

              <Typography.Text style={{ fontSize: '12px', color: '#8c8c8c' }}>
                {translate('searchOrder.orderColumn')}
              </Typography.Text>
            </div>
          </div>
        </div>

        {/* Visual example */}
        <div
          style={{
            textAlign: 'center',
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          }}
        >
          <img
            src={isFr ? '/aide_retour.jpg' : '/your_order_number.jpg'}
            alt={translate('img.returnHelp')}
            style={{
              width: '80%',
              maxWidth: '960px',
              height: 'auto',
              borderRadius: '12px',
              border: '4px solid #1890ff',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
            }}
          />
        </div>

        {/* Close button */}
        <div style={{ textAlign: 'center' }}>
          <Button
            type="primary"
            size="large"
            onClick={onClose}
            style={{
              minWidth: '260px',
              height: '52px',
              fontSize: '18px',
              fontWeight: 600,
              borderRadius: '8px',
            }}
          >
            {translate('searchOrder.understood')} 👍
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ClientIdHelpModal;
